import FeatureImage from "./feature-image";

export default FeatureImage;
